import { registerFigure } from "./base.js";
/**
 * Rows and columns of dots. The picture that makes multiplication stop being a
 * fact to memorise: 7 × 8 is seven rows of eight, and you can count them.
 *
 * Also carries grouping, equal shares and repeated addition, which is most of
 * what "maths" means to a child in this age range.
 */
export const arrayFigure = registerFigure({
    kind: "array",
    summary: "A grid of dots, rows × columns.",
    chooseWhen: "The idea is a multiplication, a grouping, or equal shares — anything a " +
        "child could check by counting. Rows and columns must be the actual " +
        "numbers in the answer, never a decoration.",
    issues(figure) {
        const issues = [];
        if (!figure.rows || !figure.cols) {
            issues.push("An array figure needs both rows and cols.");
        }
        // 144 dots is not a picture, it's a wall. The point is countability.
        if ((figure.rows ?? 0) * (figure.cols ?? 0) > 100) {
            issues.push("An array over 100 dots stops being countable.");
        }
        return issues;
    },
    normalise(figure) {
        return { kind: "array", caption: figure.caption, rows: figure.rows, cols: figure.cols };
    },
    example: { kind: "array", caption: "Seven rows of eight makes 56.", rows: 7, cols: 8 },
});
//# sourceMappingURL=array.js.map